<template>
  <div class="bzlu-leitsystem">
    <!-- Diagonaler Hintergrund-Streifen -->
    <div
      class="bzlu-diagonal"
      aria-hidden="true"
    ></div>

    <!-- Logo -->
    <div class="bzlu-header">
      <img
        src="https://bzlu-test.bx-education.ch/documents/19DB09EC6CF.svg"
        alt="BZLU Bildungszentrum Luzern"
        class="bzlu-logo"
      />
    </div>

    <!-- Tabelle -->
    <div class="bzlu-content">
      <b-table
        ref="selectableTable"
        tbody-tr-class="bzlu-row"
        responsive
        :items="displayzeiten"
        :fields="fields"
      >
        <template v-slot:cell(dozierende)="row">
          <div>
            {{
              row.item.verantwortlich
                ? row.item.verantwortlich.personName
                : row.item.bemerkung
            }}
          </div>
        </template>
      </b-table>
    </div>

    <!-- Footer: Uhrzeit links, Datum rechts -->
    <div class="bzlu-footer">
      <span>{{ clockstamp }}</span>
      <span>{{ datestamp }}</span>
    </div>
  </div>
</template>

<script>
  import ApiLeitsystem from '@/ApiLeitsystem'
  import store from '@/store'
  import page from '@/mixins/Page'

  export default {
    name: 'LeitsystemBzlu',
    mixins: [page],
    store,
    data() {
      return {
        page: 1,
        zeiten: [],
        displayzeiten: [],
        clockstamp: '',
        datestamp: '',
        fields: [
          {
            key: 'von_uhrzeit',
            label: 'Von',
            class: 'text-center',
          },
          {
            key: 'bis_uhrzeit',
            label: 'Bis',
            class: 'text-center',
          },
          {
            key: 'veranstaltung.beschreibung',
            label: 'Klasse',
          },
          {
            key: 'bezeichnung',
            label: 'Veranstaltung',
            formatter: (value) => {
              return value ? value : '-'
            },
          },
          {
            key: 'dozierende',
            class: 'text-left',
            label: 'Dozierende',
          },
          {
            key: 'raeumeleitsystem',
            class: 'text-left',
            label: 'Raum',
          },
        ],
      }
    },
    mounted() {
      this.getTimeTable()
      this.updateClock()

      let that = this

      // Daten alle 15 Minuten neu laden
      setInterval(function () {
        that.getTimeTable()
      }, 900 * 1000)

      // Seitenwechsel jede Minute
      setInterval(function () {
        that.switchDisplay()
      }, 60 * 1000)

      // Uhr jede 15 Sekunden aktualisieren
      setInterval(function () {
        that.updateClock()
      }, 15 * 1000)

      $('body').css('overflow', 'hidden')
    },
    methods: {
      updateClock() {
        const now = new Date()

        this.clockstamp = now.toLocaleTimeString('de-CH', {
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
        })

        const weekDay = now.toLocaleString('de-CH', { weekday: 'long' })
        const month = now.toLocaleString('de-CH', { month: 'long' })
        this.datestamp =
          weekDay.charAt(0).toUpperCase() +
          weekDay.slice(1) +
          ', ' +
          now.getDate() +
          '. ' +
          month.charAt(0).toUpperCase() +
          month.slice(1) +
          ' ' +
          now.getFullYear()
      },

      switchDisplay() {
        if (!this.zeiten) return

        const count = this.zeiten.length

        if (count / 12 > this.page) this.page++
        else this.page = 1

        this.displayzeiten = this.zeiten.slice(
          (this.page - 1) * 12,
          this.page * 12
        )
      },

      getTimeTable() {
        const heute = new Date()

        ApiLeitsystem.get('/apileitsystem/', {
          params: {
            count: 99,
            offset: 0,
            vondate:
              heute.getDate() +
              '.' +
              (heute.getMonth() + 1) +
              '.' +
              heute.getFullYear(),
            vontime: heute.getHours() - 1 + ':00',
            bisdate:
              heute.getDate() +
              '.' +
              (heute.getMonth() + 1) +
              '.' +
              heute.getFullYear(),
            bistime: '23:59',
          },
        }).then((response) => {
          this.zeiten = response.data
          this.page = 0
          this.switchDisplay()
        })
      },
    },
  }
</script>

<style scoped>
  .bzlu-leitsystem {
    position: relative;
    width: 100vw;
    height: 100vh;
    background: #ffffff;
    overflow: hidden;
    font-family: 'Open Sans', sans-serif;
  }

  .bzlu-diagonal {
    position: absolute;
    width: 100%;
    height: 100%;
    background-image: url('https://bzlu-test.bx-education.ch/documents/19DB40A01FF.svg');
    background-repeat: no-repeat;
    background-size: 100vw auto; /* Breite = Viewport, Höhe proportional */
    background-position: calc(100% + 200px) -150px; /* X: rechts rausschieben, Y: nach oben */
    z-index: 0;
    pointer-events: none;
  }

  /* Hochformat */
  @media (orientation: portrait) {
    .bzlu-diagonal {
      background-size: auto 140vh;
    }
  }

  /* Querformat */
  @media (orientation: landscape) {
    .bzlu-diagonal {
      background-size: 140vw auto;
    }
  }

  .bzlu-header {
    position: relative;
    z-index: 1;
    padding: 32px 0 24px 40px;
  }

  .bzlu-logo {
    width: 200px;
  }

  .bzlu-content {
    position: relative;
    z-index: 1;
    padding: 0 40px;
  }

  ::v-deep .table {
    background: transparent;
  }

  ::v-deep .table thead th {
    font-weight: 700;
    color: #0e0e0d;
    border-top: none;
    border-bottom: 2px solid #0e0e0d;
    font-size: 18px;
    padding: 10px 12px;
  }

  ::v-deep .table tbody td {
    color: #0e0e0d;
    font-size: 20px;
    padding: 12px 12px;
    border-top: 1px solid #e0e0e0;
  }

  ::v-deep .table tbody tr {
    background: transparent !important;
  }

  ::v-deep .table tbody tr:hover {
    background: transparent !important;
  }

  .bzlu-footer {
    position: fixed;
    bottom: 20px;
    left: 40px;
    right: 40px;
    display: flex;
    justify-content: space-between;
    font-size: 16px;
    color: #555555;
    z-index: 1;
  }
</style>
